<template>
    <default-template>
        <v-container>
            <div class="contents-area">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 v-if="-1 < $route.path.indexOf('/center/notifications')" class="tit">공지사항</h2>
                    <h2 v-if="-1 < $route.path.indexOf('/center/faqs')" class="tit">자주묻는질문</h2>
                    <h2 v-if="-1 < $route.path.indexOf('/center/questions')" class="tit">1:1 상담문의</h2>
                </div>
                <div class="contents-area__inner">
                    <slot />
                </div>
            </div>
        </v-container>
    </default-template>
</template>
<script>
import DefaultTemplate from "../DefaultTemplate.vue";
export default {
    components: {
        DefaultTemplate,
    }
}
</script>

<style scoped>
.v-btn-toggle>>>.v-btn {
    opacity: 1 !important;
}
</style>